import { Box, FormControl } from '@primer/react';
import React, { useState } from 'react';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import ComboboxTinh from '../../../components/combobox-tinh';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import FormBlock from './FormBlock';
import ComboboxHuyen from '../../../components/combobox-huyen';
import ComboboxXa from '../../../components/combobox-xa';
import TextInput from '../../../components/ui/text-input';
interface IThongTinDiaChiProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    generatedCode?: string,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>,
    canEdit?: boolean
}
const ThongTinDiaChi = (props: IThongTinDiaChiProps) => {
    const { control, setFormData, hocSinh, setValue, generatedCode, register, errors, formData, trigger } = props;

    const [selectedProvince, setSelectedProvince] = useState<any>(
        hocSinh.dm_tinh_id || null
    );
    const [selectedDistrict, setSelectedDistrict] = useState<any>(
        hocSinh.dm_huyen_id || null
    );
    const [selectedCommune, setSelectedCommune] = useState<any>(
        hocSinh.dm_xa_id || null
    );
    const [selectedProvinceHT, setSelectedProvinceHT] = useState<any>(
        hocSinh.dm_tinh_ht_id || null
    );
    const [selectedDistrictHT, setSelectedDistrictHT] = useState<any>(
        hocSinh.dm_huyen_ht_id || null
    );
    const [selectedCommuneHT, setSelectedCommuneHT] = useState<any>(
        hocSinh.dm_huyen_ht_id || null
    );
    const handleProvinceChange = (value: any) => {
        setSelectedProvince(value);
        setSelectedDistrict(null);
        setSelectedCommune(null);
        setFormData((prev) => ({
            ...prev,
            dm_tinh_id: value,
            dm_huyen_id: 0,
            dm_xa_id: 0
        }));
    };
    const handleDistrictChange = (value: any) => {
        setSelectedDistrict(value);
        setSelectedCommune(null);
        setFormData((prev) => ({
            ...prev,
            dm_huyen_id: value,
            dm_xa_id: 0,
        }));
    };
    const handleCommuneChange = (value: any) => {
        setSelectedCommune(value);
        setFormData((prev) => ({
            ...prev,
            dm_xa_id: value,
        }));
    };
    const handleProvinceChangeHT = (value: any) => {
        setSelectedProvinceHT(value);
        setSelectedDistrictHT(null);
        setSelectedCommuneHT(null);
        setFormData((prev) => ({
            ...prev,
            dm_tinh_ht_id: value,
            dm_huyen_ht_id: 0,
            dm_xa_ht_id: 0,
        }));
    };
    const handleDistrictChangeHT = (value: any) => {
        setSelectedDistrictHT(value);
        setSelectedCommuneHT(null);
        setFormData((prev) => ({
            ...prev,
            dm_huyen_ht_id: value,
            dm_xa_ht_id: 0,
        }));
    };
    const handleCommuneChangeHT = (value: any) => {
        setSelectedCommuneHT(value);
        setFormData((prev) => ({
            ...prev,
            dm_xa_ht_id: value,
        }));
    };
    return (
        <FormBlock caption="Địa chỉ">
            <Box sx={{
                display: "grid",
                gap: 2
            }}>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4,1fr)" }}>
                    <Controller
                        name="dm_tinh_id"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Tỉnh thường trú</FormControl.Label>
                                    <ComboboxTinh
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            handleProvinceChange(value);
                                        }}
                                    />
                                </FormControl>
                            </>
                        )}
                    />
                    <Controller
                        name="dm_huyen_id"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Huyện thường trú</FormControl.Label>
                                    <ComboboxHuyen
                                        dm_tinh_id={selectedProvince}
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            handleDistrictChange(value);
                                        }}
                                        key={`district-${selectedProvince}`}
                                    />
                                </FormControl>
                            </>
                        )}
                    />
                    <Controller
                        name="dm_xa_id"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Xã thường trú</FormControl.Label>
                                    <ComboboxXa
                                        dm_huyen_id={selectedDistrict}
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            handleCommuneChange(value);
                                        }}
                                        key={`commune-${selectedProvince}-${selectedDistrict}`}
                                    />
                                </FormControl>
                            </>
                        )}
                    />

                    <FormControl>
                        <FormControl.Label>Địa chỉ thường trú</FormControl.Label>
                        <TextInput
                            block
                            name="dia_chi_tt"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền địa chỉ thường trú"
                        />
                    </FormControl>


                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4, 1fr)" }}>
                    <Controller
                        name="dm_tinh_ht_id"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Tỉnh hiện tại</FormControl.Label>
                                    <ComboboxTinh
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            handleProvinceChangeHT(value);
                                        }}
                                    />
                                </FormControl>
                            </>
                        )}
                    />
                    <Controller
                        name="dm_huyen_ht_id"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Huyện hiện tại</FormControl.Label>
                                    <ComboboxHuyen
                                        dm_tinh_id={selectedProvinceHT}
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            handleDistrictChangeHT(value);
                                        }}
                                        key={`district-${selectedProvinceHT}`}
                                    />
                                </FormControl>
                            </>
                        )}
                    />
                    <Controller
                        name="dm_xa_ht_id"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Xã hiện tại</FormControl.Label>
                                    <ComboboxXa
                                        dm_huyen_id={selectedDistrictHT}
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            handleCommuneChangeHT(value);
                                        }}
                                        key={`commune-${selectedProvinceHT}-${selectedDistrictHT}`}
                                    />
                                </FormControl>
                            </>
                        )}
                    />
                    <FormControl>
                        <FormControl.Label>Nơi ở hiện tại</FormControl.Label>
                        <TextInput
                            block
                            name="dia_chi_hientai"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền nơi ở hiện tại"
                        />
                    </FormControl>
                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(2, 1fr)" }}>
                    <FormControl>
                        <FormControl.Label>Nơi sinh</FormControl.Label>
                        <TextInput
                            block
                            name="dia_chi_noi_sinh"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền nơi sinh"
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Quê quán</FormControl.Label>
                        <TextInput
                            block
                            name="que_quan"
                            register={register}
                            errors={errors}
                            required={false}
                            validateMessage="Vui lòng điền quê quán"
                        />
                    </FormControl>
                </Box>
            </Box>
        </FormBlock>
    );
};

export default ThongTinDiaChi;